import { Directive } from '@angular/core';
import { DATE_ONLY_FORMAT_PROVIDER } from '../../ngx-material-components.providers';

/**
 * Turns a single <ngx-mat-datetime-picker> input into a date-only input.
 *
 * The picker's [hideTime] removes the time spinners from the calendar panel, but the input text
 * is rendered from NGX_MAT_DATE_FORMATS, which is provided app-wide as 'yyyy-MM-dd HH:mm:ss' -
 * so a date-only field would still display ' 00:00:00'. NgxMatDatetimeInput resolves that token
 * from its element injector, and every directive on an element shares that injector, so putting
 * the override here scopes it to the one input this directive is applied to. Date & Time inputs
 * simply omit the directive and keep the app-wide format.
 *
 * Use it together with [hideTime]="true" on the picker; the two cover the panel and the input.
 */
@Directive({
  selector: '[appDateOnlyFormat]',
  providers: [DATE_ONLY_FORMAT_PROVIDER],
})
export class DateOnlyFormatDirective {}
